import PropTypes from 'prop-types';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

export default function CardTitle({ children }) {
  return <h3 className="mb-4 text-xl font-semibold lg:text-2xl">{children}</h3>;
}

CardTitle.defaultProps = defaultProps;
CardTitle.propTypes = propTypes;
